import { combineEpics } from 'redux-observable';

import { _reducer } from './ManageUsers.reducers';
import _epics from './ManageUsers.epics';

export const epics = combineEpics(_epics);

export { _reducer };
export * from './ManageUsers.actions';
